import { render, staticRenderFns } from "./widget-image-cropper.vue?vue&type=template&id=78516948&scoped=true&"
import script from "./widget-image-cropper.vue?vue&type=script&lang=js&"
export * from "./widget-image-cropper.vue?vue&type=script&lang=js&"
import style0 from "./widget-image-cropper.vue?vue&type=style&index=0&id=78516948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78516948",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VContainer,VIcon,VProgressCircular,VSpacer})
